import { Button, Tooltip, TooltipTrigger, type ButtonProps } from "@hopper-ui/components";
import "./AssistantMessageToolbarButton.css";
import "./AssistantMessageToolbarButton.dark.css";

interface Props extends ButtonProps {
    tooltip: string;
    isSelected?: boolean;
}

export const AssistantMessageToolbarButton = ({ children, tooltip, isSelected, ...rest }: Props) => {
    return (
        <TooltipTrigger>
            <Button
                {...rest}
                size="xs"
                variant="ghost-secondary"
                width="core_240"
                height="core_240"
                className={["wai-assistant-message-toolbar-button", isSelected ? "wai-assistant-message-toolbar-button-selected" : null].filter(Boolean).join(" ")}
                border="none"
            >
                {children}
            </Button>
            <Tooltip>
                {tooltip}
            </Tooltip>
        </TooltipTrigger>
    );
};
